import React from "react";
import { Typography, Paper, Button, Stack } from "@mui/material";
import CodeIcon from "@mui/icons-material/Code";
import LaunchIcon from "@mui/icons-material/Launch";

const ProjectCard = ({ post }) => {
  return (
    <Paper
      elevation={3}
      sx={{
        p: 3,
        mb: 4,
        // border: "1px solid",
        borderColor: "divider",
        backgroundColor: "background.paper",
      }}
    >
      <Typography variant="h6" gutterBottom>
        Explore this Project
      </Typography>

      <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
        <Button
          variant="outlined"
          color="primary"
          href={post.source || undefined}
          target="_blank"
          rel="noopener noreferrer"
          disabled={!post.source}
          startIcon={<CodeIcon />}
        >
          {post.source ? "View Code" : "No Source"}
        </Button>

        <Button
          variant="contained"
          color="primary"
          href={post.demo || undefined}
          target="_blank"
          rel="noopener noreferrer"
          disabled={!post.demo}
          startIcon={<LaunchIcon />}
        >
          Open
        </Button>
      </Stack>
    </Paper>
  );
};

export default ProjectCard;
